import { useEffect, useState } from "react";
import {
  TableColumn,
} from "../../../components/CommnTable/CustomDataTable";
import { StudentEvaluationList } from "../../../types/types";
import { Button, Box, Chip } from "@mui/material";
import { blue } from '@mui/material/colors';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { useLoader } from "../../../Loader/LoaderContext";
import { useGet } from "../../../services/hooks/useGet";
import { GetUrl } from "../../../api/endpointConfig";
import { getStatusChipColor } from "../../../utils/common"

const useStudentEvaluation = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const { showLoader, hideLoader } = useLoader();
  const [offsetValue, setOffsetValue] = useState<number>(0);
  const [limitValue, setLimitValue] = useState<number>(10);
  const [queryParams, setQueryParams] = useState<any>({})

  const pagination: Record<string, string | number| null> = {
    offset: offsetValue,
    limit: limitValue,
  };

  const { data = [], isLoading, isError } = useGet<any>(
    `${GetUrl.getOngoingEvaluation}`, { params: {...pagination,...queryParams} }
  );
  
  useEffect(() => {
    const prefix = searchParams.get('prefix');
    const text = searchParams.get('text');
    setQueryParams((prev: any) => {
      const updated = { ...prev };

      if (text && prefix) {
        updated[prefix] = text;
      } else {
        setQueryParams({})
      }
      return updated;
    });
  }, [searchParams])

  const HandlePagination = (e: any) => {
    setLimitValue(e.rows)
    setOffsetValue(e.page + 1)

  }

  useEffect(() => {
    if (isLoading && !isError) {
      showLoader()
    } else if (isError) { hideLoader() }
    else { hideLoader() }
  }, [isLoading, isError])


  const columns: TableColumn<StudentEvaluationList>[] = [

    {
      field: "scholarship_id", header: "Scholarship Id", width: "8rem", sortable: true,filterable: true, customBody: (row) => (
        <Button sx={{ color: blue[700] }} onClick={() =>
          navigate(`/scholarship-summary/${row.user_id}`)
        }>{row.scholarship_id}</Button>
      )
    },
    { field: "name", header: "Name", sortable: true,filterable: true, width: "4rem" },
    { field: "course", header: "Course", sortable: true,filterable: true, width: "4rem" },
    {
      field: "status", header: "Status", sortable: true,filterable: true, width: "4rem", customBody: (row: any) => (
        <Chip
          label={row.status}
          color={getStatusChipColor(row.status)}
          size="small"
          variant="filled"
          style={{ fontWeight: 600, textTransform: "capitalize" }}
        />
      )
    },
    { field: "evaluation_date", header: "EvaluationDate", sortable: true,filterable: true, width: "4rem" },
    {
      field: "action", header: "Action", width: "4rem", customBody: (row) => (
        <Box sx={{ display: "flex" }}>
          <Button variant="contained" sx={{ bgcolor: blue[700], marginRight: 2, width: "40%" }} onClick={() => {
            localStorage.setItem("StudentEvaluation", JSON.stringify(row));
            navigate(`/student-evaluation-view/${row.id}`)
          }
          }>View</Button>
          <Button startIcon={<AddIcon />} variant="contained" color="success" sx={{ width: "70%" }} onClick={() => {
            localStorage.setItem("StudentEvaluation", JSON.stringify(row));
            navigate(`/student-evaluation-new`)
          }
          }>New Evaluation</Button>
        </Box>
      )
    }
  ];

  return { columns, HandlePagination, data, limitValue }
}

export default useStudentEvaluation